import React, { useState } from "react";

const LoginForm = ({ onLogin, error }) => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        onLogin(username, password);
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center p-4">
            <div className="w-full max-w-md">
                <div className="bg-gray-800 rounded-2xl shadow-2xl p-8 border border-gray-700">
                    <div className="text-center mb-8">
                        <h1 className="text-3xl font-bold text-white mb-2">Welcome</h1>
                        <p className="text-gray-400">Please sign in to continue</p>
                    </div>
                    
                    {error && (
                        <div className="mb-6 p-4 bg-red-900/50 text-red-200 rounded-lg border border-red-800">
                            {error}
                        </div>
                    )}
                    
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-300 mb-2">
                                Username
                            </label>
                            <input
                                type="text"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg
                                focus:outline-none focus:ring-2 focus:ring-blue-500 
                                focus:border-transparent text-white placeholder-gray-400
                                transition-colors duration-200"
                                placeholder="Enter your username"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-300 mb-2">
                                Password
                            </label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg
                                focus:outline-none focus:ring-2 focus:ring-blue-500 
                                focus:border-transparent text-white placeholder-gray-400
                                transition-colors duration-200"
                                placeholder="Enter your password"
                            />
                        </div>
                        <button
                            type="submit"
                            className="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white py-3 px-4 rounded-lg
                            hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 
                            focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-800
                            transition-all duration-200 font-medium shadow-lg hover:shadow-xl"
                        >
                            Sign In
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default LoginForm;